export default __webpack_public_path__ + "static/psm1-01-ff772538d2ee1ba4207bfe834ffb693d.png";